module.exports = __webpack_public_path__ + "img/diageo-distillery-building-site.8594cf18.png";